import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

function PasswordOutLinedField({
  id,
  label = "password",
  innerRef,
  className,
  hint,
  ...rest
}) {
  const [showPassword, setShowPassword] = useState(false);

  const handleCopyPaste = (event) => {
    event.preventDefault();
  };

  return (
    <div className={`flex flex-col space-y-2 ${className}`}>
      <label htmlFor={id} className="text-[16px] font-semibold text-primary">
        {label}
      </label>
      <div className="relative">
        <input
          ref={innerRef}
          type={showPassword ? "text" : "password"}
          aria-describedby={hint ? `${id}-hint` : undefined}
          {...rest}
          className="w-full rounded-md border px-4 py-2 outline-none autofill-color focus:ring-2 focus:ring-primary lg:w-full"
          onCopy={handleCopyPaste}
          onPaste={handleCopyPaste}
        />
        {showPassword ? (
          <FiEye
            className="absolute right-3 top-1/2 -translate-y-1/2 transform cursor-pointer"
            onClick={() => setShowPassword(false)}
          />
        ) : (
          <FiEyeOff
            className="absolute right-3 top-1/2 -translate-y-1/2 transform cursor-pointer"
            onClick={() => setShowPassword(true)}
          />
        )}
      </div>
      {hint && (
        <p id={`${id}-hint`} className="text-[13px] text-gray-500">
          {hint}
        </p>
      )}
    </div>
  );
}

export default PasswordOutLinedField;
